<template>
<div class="view-schedule-dashboard-email">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
        <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateShowScheduledDashboardEmailOverlayFlag(false)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              
                <div class="row margin-top-3Perc vertical-align" v-if="(selectedGCCUArrValue.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc">
                      <table class="table table-striped ">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-left border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Group Course</th>
                            <th class="text-align-center font-size-15px border-right">Cohort</th>
                            <th class="text-align-center font-size-15px border-right">Selected Users</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in selectedGCCUArrValue" :key="('update-' + currObj.groupObj.GroupId + '-' + currObj.courseObj.GroupCourseMasterId + '-' + currObj.cohortObj.CohortId)">
                            <td class="border-left border-right text-align-center col-lg-1">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.groupObj.GroupName}} :: {{(currObj.courseObj.CourseTitle + ' [' + currObj.courseObj.CourseSubTitle + ']')}}</td>
                            <td class="border-right text-align-center col-lg-3">{{currObj.cohortObj.CohortName}}</td>
                            <td class="border-right text-align-left col-lg-3" v-html="getFormattedSelectedUserList(currObj.selectedUsersFullName)"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <hr width="94%" size="10px"/>
                <div class="row margin-top-2Perc vertical-align">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
                    <i><u>Who is sending?</u></i>
                    </div>
                </div>
                <div class="row margin-top-2Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>Name</b>
                    </div>
                  <div class="col-sm-4 col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0px text-align-left">
                        {{ senderNameValue }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                    <b>Email</b>
                  </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0px text-align-left">
                        {{ senderEmailValue }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <hr width="94%" size="10px"/>

                <div class="row margin-top-2Perc vertical-align">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
                    <i>Who wants <u>to</u> recieve it?</i>
                    </div>
                </div>

                <div class="row margin-top-3Perc vertical-align" v-if="(toEmailsArr.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped ">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-left border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Name</th>
                            <th class="text-align-center font-size-15px border-right">EmailId</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in toEmailsArr" :key="'to_' + index">
                            <td class="border-left border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Name}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Email}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <div class="row margin-top-1Perc vertical-align" v-else>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-15px text-color-red">
                    <i>Records Not Found</i>
                  </div>
                </div>

                <hr width="94%" size="10px"/>

                <div class="row margin-top-2Perc vertical-align">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
                    <i>Want to send as carbon copy <u>(CC)</u>?</i>
                    </div>
                </div>

                <div class="row margin-top-3Perc vertical-align" v-if="(ccEmailArr.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped ">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-left border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Name</th>
                            <th class="text-align-center font-size-15px border-right">EmailId</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in ccEmailArr" :key="'to_' + index">
                            <td class="border-left border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Name}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Email}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <div class="row margin-top-1Perc vertical-align" v-else>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-15px text-color-red">
                    <i>Records Not Found</i>
                  </div>
                </div>

                <hr width="94%" size="10px"/>

                <div class="row margin-top-2Perc vertical-align">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
                    <i>Want to send as black carbon copy <u>(BCC)</u>?</i>
                    </div>
                </div>

                <div class="row margin-top-3Perc vertical-align" v-if="(bccEmailArr.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-left border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Name</th>
                            <th class="text-align-center font-size-15px border-right">EmailId</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in bccEmailArr" :key="'to_' + index">
                            <td class="border-left border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Name}}</td>
                            <td class="border-right text-align-center col-lg-5">{{currObj.Email}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <div class="row margin-top-1Perc vertical-align" v-else>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-15px text-color-red">
                    <i>Records Not Found</i>
                  </div>
                </div>

                <hr width="94%" size="10px"/>

                <div class="row margin-top-3Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>Want to Schedule?</b>
                    </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
                    Yes
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                    <span><b>Frequency</b></span>
                  </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
                    {{ getScheduledEmailFrequency(scheduleReportFrequencyValue) }}
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row margin-top-3Perc vertical-align" v-if="wantToScheduleEmailValue">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>StartTs</b>
                    </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
                    {{ scheduleStartTSValue }}
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                    <b>EndTs</b>
                  </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
                    {{ scheduleEndTSValue }}
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row margin-top-3Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>Comment</b>
                    </div> 
                  <div class="col-sm-9 col-md-9 col-lg-9 text-align-left">
                    {{ scheduleEmailDescValue }}
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <hr width="94%" size="10px"/>

                <div class="row margin-top-3Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>Template</b>
                    </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
                    {{ selectedEmailTemplateValue.EmailTemplateName }}
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                    <b>Subject</b>
                  </div> 
                  <div class="col-sm-4 col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-10 col-md-10 col-lg-10 text-left Padding-left-0px">
                          {{selectedEmailTemplateValue === -1 ? 'Template Not Selected' : selectedEmailTemplateValue.EmailSubject}}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row margin-top-3Perc">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    <div class=" col-md-1 col-lg-1 text-align-right Padding-right-0px">
                      <b>Content</b>
                    </div>
                    <div class="col-md-9 col-lg-9">
                      <div class="form-group">
                        <div class="col-sm-12 text-align-left border-1px-solid-grey padding-2Perc">
                          <span v-html="templateBodyText"></span>
                        </div>
                      </div>
                    </div>
                </div>

                <div class="row margin-top-3Perc">
                  <div class="col-sm-2 col-md-2 col-lg-2 text-align-right Padding-right-0px">
                    <b>Previous Attached Files</b>
                  </div>
                  <div class="col-sm-9 col-md-9 col-lg-9 text-align-left">
                    <div v-for="(attachedFileObjUrl, index) in attachedEmailFilesArrValue" :key="index">
                      <span class="text-align-left margin-right-3Perc">{{(index + 1) + '. ' + getFileExtention(attachedFileObjUrl)}}</span><a :href="attachedFileObjUrl"><span class="glyphicon glyphicon-cloud-download cursor-pointer text-color-green-only text-align-right"></span></a>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-9 col-lg-9 text-align-left" v-if="attachedEmailFilesArrValue.length === 0">
                    <span class="text-align-left">Not Found</span>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                
                <div class="row margin-top-3Perc margin-bottom-3Perc">
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                  <button type="button" class="btn btn-default button-orange col-lg-offset-4 col-lg-2" @click="updateShowScheduledDashboardEmailOverlayFlag(false)">Close</button>
                </div>
                <div class="row">
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>  
</template>
<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { emailService } from '@/server-util/email-service'
import { participantService } from '@/server-util/participant-service'
import Loader from '@/components/dashboard/Loader'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import {forEach, find, findIndex, filter, concat, clone} from 'lodash'
import datePicker from 'vue-bootstrap-datetimepicker'
export default {
  props: ['currSelectedObj', 'groupCourseCohortList'],
  data: function () {
    return {
      constants: constants,
      userList: [],
      groupList: [],
      coursesList: [],
      cohortList: [],
      selectedGroupObj: -1,
      selectedCourseObj: -1,
      selectedCohortObj: -1,
      showNoUserTxtInEnrolledUserBox: true,
      showNoUserTxtInUnEnrolledUserBox: true,
      isSelectedAllUnEnrolledUser: false,
      isSelectedAllEnrolledUser: false,
      selectedEnrolledUserIdArr: [],
      selectedUnEnrolledUserIdArr: [],
      selectedGCCUArr: [],
      senderObj: {
        Name: '',
        Email: ''
      },
      toEmailObj: {
        Name: '',
        Email: ''
      },
      ccEmailObj: {
        Name: '',
        Email: ''
      },
      bccEmailObj: {
        Name: '',
        Email: ''
      },
      toEmailsArr: [],
      ccEmailArr: [],
      bccEmailArr: [],
      selectedCourseIds: [],
      selectedUserIds: [],
      senderEmails: [],
      selectedEmailTemplate: -1,
      templateBodyText: '',
      attachedEmailFilesArr: [],
      deletedAttachmentsArr: [],
      originalDashboardEmailTemplateResp: null,
      sendOrScheduledEmailSuccessfully: false,
      wantToScheduleEmail: false,
      scheduleStartTS: new Date(),
      scheduleEndTS: new Date(),
      scheduleReportFrequency: -1,
      showEditUI: false,
      configForStartTs: {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true
      },
      configForEndTs: {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true
      },
      scheduleEmailDesc: '',
      userObj: this.$store.state.curr_user
    }
  },
  created: function () {
    this.setDefaultValues()
    this.getCurrentTemplateList()
    this.getGroups()
  },
  components: {
    'loader': Loader,
    'date-picker': datePicker
  },
  computed: {
    groupCourseCohortListValue: {
      get: function () {
        return this.groupCourseCohortList
      },
      set: function (newValue) {
        this.groupCourseCohortList = newValue
      }
    },
    scheduleEmailDescValue: {
      get: function () {
        return this.scheduleEmailDesc
      },
      set: function (newValue) {
        this.scheduleEmailDesc = newValue
      }
    },
    scheduleStartTSValue: {
      get: function () {
        return this.scheduleStartTS
      },
      set: function (newValue) {
        this.scheduleStartTS = newValue
      }
    },
    scheduleEndTSValue: {
      get: function () {
        return this.scheduleEndTS
      },
      set: function (newValue) {
        this.scheduleEndTS = newValue
      }
    },
    scheduleReportFrequencyValue: {
      get: function () {
        return this.scheduleReportFrequency
      },
      set: function (newValue) {
        this.scheduleReportFrequency = parseInt(newValue)
      }
    },
    wantToScheduleEmailValue: {
      get: function () {
        return this.wantToScheduleEmail
      },
      set: function (newValue) {
        this.wantToScheduleEmail = newValue
      }
    },
    senderObjValue: {
      get: function () {
        return this.senderObj
      },
      set: function (newValue) {
        this.senderObj = newValue
      }
    },
    senderNameValue: {
      get: function () {
        return this.senderObj.Name
      },
      set: function (newValue) {
        this.senderObj.Name = newValue
      }
    },
    senderEmailValue: {
      get: function () {
        return this.senderObj.Email
      },
      set: function (newValue) {
        this.senderObj.Email = newValue
      }
    },
    toEmailObjValue: {
      get: function () {
        return this.toEmailObj
      },
      set: function (newValue) {
        this.toEmailObj = newValue
      }
    },
    toNameValue: {
      get: function () {
        return this.toEmailObjValue.Name
      },
      set: function (newValue) {
        this.toEmailObjValue.Name = newValue
      }
    },
    toEmailValue: {
      get: function () {
        return this.toEmailObjValue.Email
      },
      set: function (newValue) {
        this.toEmailObjValue.Email = newValue
      }
    },
    ccEmailObjValue: {
      get: function () {
        return this.ccEmailObj
      },
      set: function (newValue) {
        this.ccEmailObj = newValue
      }
    },
    ccNameValue: {
      get: function () {
        return this.ccEmailObjValue.Name
      },
      set: function (newValue) {
        this.ccEmailObjValue.Name = newValue
      }
    },
    ccEmailValue: {
      get: function () {
        return this.ccEmailObjValue.Email
      },
      set: function (newValue) {
        this.ccEmailObjValue.Email = newValue
      }
    },
    bccEmailObjValue: {
      get: function () {
        return this.bccEmailObj
      },
      set: function (newValue) {
        this.bccEmailObj = newValue
      }
    },
    bccNameValue: {
      get: function () {
        return this.bccEmailObjValue.Name
      },
      set: function (newValue) {
        this.bccEmailObjValue.Name = newValue
      }
    },
    bccEmailValue: {
      get: function () {
        return this.bccEmailObjValue.Email
      },
      set: function (newValue) {
        this.bccEmailObjValue.Email = newValue
      }
    },
    selectedCohortObjValue: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedCohortObj !== -1) {
          this.getAssociatedUserList()
        }
      }
    },
    selectedCourseObjValue: {
      get: function () {
        return this.selectedCourseObj
      },
      set: function (newValue) {
        this.selectedCourseObj = newValue
        this.cohortList = []
        this.selectedCohortObjValue = -1
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedCourseObj !== -1) {
          this.getAssociatedCohortList()
        }
      }
    },
    selectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newValue) {
        this.selectedGroupObj = newValue
        this.selectedCourseObjValue = -1
        this.selectedCohortObjValue = -1
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedGroupObj !== -1) {
          this.getGroupCourses()
        }
      }
    },
    userListValue: {
      get: function () {
        return this.userList
      },
      set: function (newValue) {
        this.userList = newValue
      }
    },
    enrolledUserListValue: {
      get: function () {
        return filter(this.userList, (obj) => {
          return !obj.Unenrolled
        })
      }
    },
    unEnrolledUserListValue: {
      get: function () {
        return filter(this.userList, (obj) => {
          return obj.Unenrolled
        })
      }
    },
    selectedUnEnrolledUserIdArrValue: {
      get: function () {
        return this.selectedUnEnrolledUserIdArr
      },
      set: function (newValue) {
        this.selectedUnEnrolledUserIdArr = newValue
        this.isSelectedAllUnEnrolledUser = (this.selectedUnEnrolledUserIdArr.length > 0 && this.unEnrolledUserListValue.length === this.selectedUnEnrolledUserIdArr.length)
      }
    },
    selectedEnrolledUserIdArrValue: {
      get: function () {
        return this.selectedEnrolledUserIdArr
      },
      set: function (newValue) {
        this.selectedEnrolledUserIdArr = newValue
        this.isSelectedAllEnrolledUser = (this.selectedEnrolledUserIdArr.length > 0 && this.enrolledUserListValue.length === this.selectedEnrolledUserIdArr.length)
      }
    },
    isSelectedAllUnEnrolledUserValue: {
      get: function () {
        return this.isSelectedAllUnEnrolledUser
      },
      set: function (newValue) {
        this.isSelectedAllUnEnrolledUser = newValue
        this.selectedUnEnrolledUserIdArr = []
        if (newValue) {
          this.selectedUnEnrolledUserIdArr = []
          for (var i = 0; i < this.userListValue.length; i++) {
            if (this.userListValue[i].Unenrolled) {
              this.selectedUnEnrolledUserIdArr.push(this.userListValue[i].UserId)
            }
          }
        }
      }
    },
    isSelectedAllEnrolledUserValue: {
      get: function () {
        return this.isSelectedAllEnrolledUser
      },
      set: function (newValue) {
        this.isSelectedAllEnrolledUser = newValue
        this.selectedEnrolledUserIdArr = []
        if (newValue) {
          this.selectedEnrolledUserIdArr = []
          for (var i = 0; i < this.userListValue.length; i++) {
            if (!this.userListValue[i].Unenrolled) {
              this.selectedEnrolledUserIdArr.push(this.userListValue[i].UserId)
            }
          }
        }
      }
    },
    selectedGCCUArrValue: {
      get: function () {
        return this.selectedGCCUArr
      },
      set: function (newValue) {
        this.selectedGCCUArr = newValue
      }
    },
    selectedEmailTemplateValue: {
      get: function () {
        return this.selectedEmailTemplate
      },
      set: function (newValue) {
        this.selectedEmailTemplate = newValue
        if (this.selectedEmailTemplate !== -1) {
          this.getSelectedEmailTemplate()
        }
      }
    },
    getGroupListValue: {
      get: function () {
        return this.groupList
      },
      set: function (newValue) {
        this.groupList = newValue
      }
    },
    getCourseListValue: {
      get: function () {
        return this.coursesList
      },
      set: function (newValue) {
        this.coursesList = newValue
      }
    },
    emailTemplatesValue: {
      get: function () {
        return this.$store.state.emailDashboardTemplateList
      },
      set: function (newValue) {
        this.$store.state.emailDashboardTemplateList = newValue
      }
    },
    attachedEmailFilesArrValue: {
      get: function () {
        return this.attachedEmailFilesArr
      },
      set: function (newValue) {
        this.attachedEmailFilesArr = newValue
      }
    }
  },
  watch: {
    groupCourseCohortListValue: function (newValue, oldValue) {
      if (oldValue.length === 0) {
        this.setDefaultValues()
      }
    }
  },
  methods: {
    getScheduledEmailFrequency: function (currFrequency) {
      var valueToReturn = ''
      switch (currFrequency) {
        case constants.ReportingTaskFrequency.None:
          valueToReturn = 'None'
          break
        case constants.ReportingTaskFrequency.Daily:
          valueToReturn = 'Daily'
          break
        case constants.ReportingTaskFrequency.Weekly:
          valueToReturn = 'Weekly'
          break
        case constants.ReportingTaskFrequency.Monthly:
          valueToReturn = 'Monthly'
          break
      }
      return valueToReturn
    },
    getUserFullNameLocally: function (currIndex) {
      if (currIndex > -1 && ((this.selectedGCCUArrValue[this.currSelectedRecordIndexForEdit].selectedUsersFullName.length) > currIndex)) {
        return this.selectedGCCUArrValue[this.currSelectedRecordIndexForEdit].selectedUsersFullName[currIndex]
      } else {
        return 'Not Found'
      }
    },
    getFileExtention: function (url) {
      return url.split(/[#?]/)[0].split('.').pop().trim()
    },
    setDefaultValues: function () {
      if (this.groupCourseCohortListValue.length > 0) {
        const foundObj = find(this.groupCourseCohortListValue, (obj) => {
          return obj.GroupId === this.currSelectedObj.GroupData.GroupId
        })
        var userIdArr = []
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          this.selectedGroupObjValue = foundObj
          this.selectedCourseObjValue = -1
          this.selectedCohortObjValue = -1
          const gccData = this.currSelectedObj.GroupData.GCCData
          forEach(gccData, (currObj, index) => {
            const courseObj = find(foundObj.CourseCohortRecord, (currCourseObj) => {
              return currObj.GroupCourseMasterId === currCourseObj.GroupCourseMasterId
            })
            if (courseObj !== undefined && courseObj !== 'undefined' && courseObj !== null && courseObj !== 'null' && courseObj !== '') {
              const cohortObj = find(courseObj.CohortData, (currCohortObj) => {
                return currObj.CohortIds === currCohortObj.CohortId
              })
              if (cohortObj !== undefined && cohortObj !== 'undefined' && cohortObj !== null && cohortObj !== 'null' && cohortObj !== '') {
                var objToPush = {
                  groupObj: foundObj,
                  courseObj: courseObj,
                  cohortObj: cohortObj,
                  userIds: currObj.UserIds,
                  copyOfUserIds: clone(currObj.UserIds),
                  selectedUsersFullName: [],
                  copyOfSelectedUsersFullName: []
                }
                this.selectedGCCUArrValue.push(objToPush)
                forEach(currObj.UserIds, (userId) => {
                  if (userIdArr.indexOf(userId) === -1) {
                    userIdArr.push(userId)
                  }
                })
              }
            }
          })
          this.getUserFullNameByUserId(userIdArr)
        }
      }
      this.wantToScheduleEmailValue = true
      this.scheduleReportFrequencyValue = this.currSelectedObj.Frequency
      this.scheduleEmailDescValue = this.currSelectedObj.Description
      this.senderObjValue = this.currSelectedObj.SenderEmail
      // this.selectedEmailTemplateValue = this.currSelectedObj.TempleteId
      this.attachedEmailFilesArrValue = (this.currSelectedObj.EmailAttachments !== undefined && this.currSelectedObj.EmailAttachments !== 'undefined' && this.currSelectedObj.EmailAttachments !== null && this.currSelectedObj.EmailAttachments !== 'null' && this.currSelectedObj.EmailAttachments !== '') ? this.currSelectedObj.EmailAttachments.split(',') : []
      this.toEmailsArr = (this.currSelectedObj.ToEmails !== undefined && this.currSelectedObj.ToEmails !== 'undefined' && this.currSelectedObj.ToEmails !== null && this.currSelectedObj.ToEmails !== 'null' && this.currSelectedObj.ToEmails !== '') ? JSON.parse(this.currSelectedObj.ToEmails) : []
      this.ccEmailArr = (this.currSelectedObj.EmailCc !== undefined && this.currSelectedObj.EmailCc !== 'undefined' && this.currSelectedObj.EmailCc !== null && this.currSelectedObj.EmailCc !== 'null' && this.currSelectedObj.EmailCc !== '') ? this.currSelectedObj.EmailCc : []
      this.bccEmailArr = (this.currSelectedObj.EmailBcc !== undefined && this.currSelectedObj.EmailBcc !== 'undefined' && this.currSelectedObj.EmailBcc !== null && this.currSelectedObj.EmailBcc !== 'null' && this.currSelectedObj.EmailBcc !== '') ? this.currSelectedObj.EmailBcc : []
      this.scheduleStartTS = dmAdminUtils.covertUtcToEst(this.currSelectedObj.StartTS)
      this.scheduleEndTS = dmAdminUtils.covertUtcToEst(this.currSelectedObj.EndTS)
    },
    getFormattedSelectedUserList: function (fullNameList) {
      var htmlStrToReturn = '<span>'
      forEach(fullNameList, (currentName, index) => {
        htmlStrToReturn += (index + 1) + '. ' + currentName + '<br/>'
      })
      htmlStrToReturn += '</span>'
      return htmlStrToReturn
    },
    updateShowScheduledDashboardEmailOverlayFlag: function (refreshRecords) {
      var objToReturn = {
        closeOverlay: true,
        refreshRecords: refreshRecords,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    getUserFullNameByUserId: function (userIdArr) {
      var _this = this
      var storeObj = this.$store
      _this.$store.state.isLoading = true
      var objToPost = {
        UserIds: JSON.stringify(userIdArr)
      }
      participantService.getUserFullName(storeObj.state.access_token, objToPost).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          _this.$store.state.isLoading = false
          forEach(this.selectedGCCUArrValue, (currGCCObj, index) => {
            var selectedUsersFullNameArr = []
            forEach(currGCCObj.userIds, (currUserId) => {
              const foundObj = find(responseObj.data, (currUserObj) => {
                return currUserObj.UserId === currUserId
              })
              if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
                var fullNameStr = foundObj.FirstName + ' ' + foundObj.LastName
                selectedUsersFullNameArr.push(fullNameStr)
              }
            })
            this.selectedGCCUArrValue[index].selectedUsersFullName = selectedUsersFullNameArr
            this.selectedGCCUArrValue[index].copyOfSelectedUsersFullName = clone(selectedUsersFullNameArr)
          })
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          // AK: Hide Spinner if error occured
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    addSelectedUsers: function () {
      if (this.selectedEnrolledUserIdArr.length === 0 && this.selectedUnEnrolledUserIdArr.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one participant to Add'
      } else {
        const foundObj = find(this.selectedGCCUArrValue, (currObj) => {
          return (this.selectedGroupObj.GroupId === currObj.groupObj.GroupId && this.selectedCourseObj.GroupCourseMasterId === currObj.courseObj.GroupCourseMasterId && this.selectedCohortObj.CohortId === currObj.cohortObj.CohortId)
        })
        if (this.selectedGCCUArrValue.length > 0 && (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '')) {
          this.showAlertDialog = true
          this.errorMsg = 'Selected group course cohort entry is already present in the list. Kindly Delete existing and then try again'
        } else {
          const combinedUserIdList = concat(this.selectedEnrolledUserIdArrValue, this.selectedUnEnrolledUserIdArrValue)
          var objToPush = {
            groupObj: this.selectedGroupObj,
            courseObj: this.selectedCourseObj,
            cohortObj: this.selectedCohortObj,
            userIds: combinedUserIdList,
            copyOfUserIds: clone(combinedUserIdList),
            selectedUsersFullName: this.getSelectedUsersName(combinedUserIdList),
            copyOfSelectedUsersFullName: clone(this.getSelectedUsersName(combinedUserIdList))
          }
          this.selectedGCCUArrValue.push(objToPush)
          // AK: Reset all upper part value to except group and course state
          this.selectedCohortObjValue = -1
        }
      }
    },
    getSelectedUsersName: function (combinedUserIdList) {
      const arrToReturn = []
      forEach(combinedUserIdList, (currUserId) => {
        const foundObj = find(this.userListValue, (currUserObj) => {
          return currUserObj.UserId === currUserId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var strToPush = foundObj.FirstName + ' ' + foundObj.LastName
          arrToReturn.push(strToPush)
        }
      })
      return arrToReturn
    },
    updateUnEnrollExplicitSelectionFlag: function () {
      this.selectedUnEnrolledUserIdArr = []
      if (this.isSelectedAllUnEnrolledUser) {
        this.selectedUnEnrolledUserIdArr = []
        for (var i = 0; i < this.userListValue.length; i++) {
          if (this.userListValue[i].Unenrolled) {
            this.selectedUnEnrolledUserIdArr.push(this.userListValue[i].UserId)
          }
        }
      }
    },
    updateEnrollExplicitSelectionFlag: function () {
      this.selectedEnrolledUserIdArr = []
      if (this.isSelectedAllEnrolledUser) {
        this.selectedEnrolledUserIdArr = []
        for (var i = 0; i < this.userListValue.length; i++) {
          if (!this.userListValue[i].Unenrolled) {
            this.selectedEnrolledUserIdArr.push(this.userListValue[i].UserId)
          }
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.sendOrScheduledEmailSuccessfully) {
        this.clearAllFields()
        this.updateShowScheduledDashboardEmailOverlayFlag(true)
      }
    },
    showAddTemplate: function () {
      this.showAddTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showUpdateTemplate () {
      if (this.selectedEmailTemplateValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.showUpdateTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showDeleteTemplateConfirmation () {
      if (this.selectedEmailTemplateValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.showConfirmationBox = true
      this.$store.state.isOverlayVisible = true
      this.postTemplateString = '\'' + this.selectedEmailTemplateValue.EmailTemplateName + '\' template?'
    },
    closeTemplateOverlay () {
      this.$store.state.isOverlayVisible = false
      if (this.showAddTemplateOverlay) {
        this.showAddTemplateOverlay = false
      }
      if (this.showUpdateTemplateOverlay) {
        this.showUpdateTemplateOverlay = false
      }
      if (this.selectedEmailTemplateValue !== -1) {
        this.getSelectedEmailTemplate()
      }
    },
    getGroups: function () {
      var store = this.$store
      var _this = this
      this.getGroupListValue = store.state.groupList
      if (store.state.groupList.length === 0) {
        _this.$store.state.isLoading = true
      }
      groupService.listGroups(store.state.access_token).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          store.state.groupList = responseObj.data
          _this.getGroupListValue = responseObj.data
          _this.$store.state.isLoading = false
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        // AK: Hide Spinner if error occured
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getGroupCourses: function () {
      var _this = this
      var store = this.$store
      this.$store.state.isLoading = true
      groupCourseService.listGroupCoursesMaster(store.state.access_token, this.selectedGroupObj.GroupId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.getCourseListValue = responseObj.data
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCourseObjValue !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedCourseObjValue.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedCourseObjValue.CourseSubTitle === null ? '' : ' [' + this.selectedCourseObjValue.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedCourseObjValue.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.cohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAssociatedUserList () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCohortObj.CohortId !== undefined
      ) {
        _this.$store.state.isLoading = true
        cohortService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId,
            this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.errorMsg = 'No user found in \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showAlertDialog = true
              }
              this.userList = responseObj.data
              this.showNoUserTxtInEnrolledUserBox = (this.enrolledUserListValue.length === 0)
              this.showNoUserTxtInUnEnrolledUserBox = (this.unEnrolledUserListValue.length === 0)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CohortId is NULL hence declined GET PARTICIPANT LIST OPERATION'
        )
      }
    },
    getCurrentTemplateList: function () {
      var store = this.$store
      var _this = this
      var token = store.state.access_token
      store.state.emailDashboardTemplateList = []
      emailService.getTemplateList(token, constants.EmailTemplateType.Dashboard_Email).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          store.state.emailDashboardTemplateList = responseObj.data
          this.emailTemplatesValue = store.state.emailDashboardTemplateList
          this.selectedEmailTemplateValue = find(this.emailTemplatesValue, (currObj) => {
            return this.currSelectedObj.TempleteId === currObj.EmailTemplateId
          })
          this.$store.state.isLoading = false
        }
      }, errorObj => {
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getSelectedEmailTemplate: function () {
      var store = this.$store
      var token = store.state.access_token
      emailService.getTemplateText(token, this.selectedEmailTemplate.EmailTemplateId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          this.$store.state.isLoading = false
          this.templateBodyText = responseObj.data.EmailTemplateText
          const orgContent = dmAdminUtils.removeTFromUrls(this.templateBodyText)
          this.templateBodyText = orgContent
          this.selectedEmailTemplate.EmailTemplateText = responseObj.data.EmailTemplateText
          const index = findIndex(this.emailTemplatesValue, {EmailTemplateId: this.selectedEmailTemplate.EmailTemplateId})
          if (index) {
            this.emailTemplatesValue[index].EmailTemplateText = responseObj.data.EmailTemplateText
          }
        }
      }, errorObj => {
        this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getGCCDataObj: function () {
      var objToReturn = {
        GroupId: this.selectedGroupObj.GroupId,
        GCCData: []
      }
      forEach(this.selectedGCCUArrValue, (obj) => {
        var childObj = {
          GroupCourseMasterId: obj.courseObj.GroupCourseMasterId,
          CourseMasterId: obj.courseObj.CourseMasterId,
          CohortIds: obj.cohortObj.CohortId,
          UserIds: obj.userIds
        }
        objToReturn.GCCData.push(childObj)
      })
      return objToReturn
    }
  },
  name: 'view-schedule-dashboard-email'
}
</script>

<style scoped>
.padding-2Perc {
  padding: 2%;
}
.border-1px-solid-grey {
  border: 1px dotted #aaa;
}
.text-color-red {
  color: red;
}
.text-color-green-only {
  color: green;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}

.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.text-color-green {
  color: green;
  background: white;
  border-radius: 50%;
  border: 1px solid gainsboro;
  padding: 5px;
}
.text-color-red {
  color: red;
}
.margin-bottom-10px {
  margin-bottom: 10px;
}
.immidiate-dashboard-email {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.overflow-y-enabled{
  overflow-y: auto
}
.leftAlign{
  text-align: left;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.text-align-center {
  text-align: center !important;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.text-align-left {
  text-align: left !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-left-5perc {
  margin-left: 5%;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-1perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}

.font-size-15px {
  font-size: 15px;
}
.alignCenter{
  align: center;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.align-center{
  align:center !important;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.border-1px{
  border: 1px solid #ccc;
}
.padding-15px{
  padding:15px;
}
.width-90Perc{
  width: 90% !important;
}
.margin-bottom-7Perc{
  margin-bottom: 7%;
}
.margin-bottom-5Perc{
  margin-bottom: 5%;
}
.margin-bottom-3Perc{
  margin-bottom: 3%;
}
.text-align-right{
text-align: right;
}
.padding-left-0Perc{
 padding-left:0%; 
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.padding-top-7px{
  padding-top: 7px;
}
.floatLeft {
  float: left;
}
.cursor-pointer{
  cursor: pointer;
}
.padding-top-10px {
  padding-top: 10px;
}
.font-weight-normal {
  font-weight: normal
}
.Padding-right-0px {
  padding-right: 0px !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-left{
    text-align: left !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red {
  border: 1px solid red;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.border-left {
  border-left: 1px solid #aaa !important;
}
.padding-left-0px {
  padding-left: 0px;
}
.padding-right-0px {
  padding-right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/emails/dashboard_emails/ViewScheduleDashboardEmail.vue